import { PlatformSource } from '@/api/types/common.types';

export const FLOATING_THRESHOLD = {
  [PlatformSource.App]: 6,
  [PlatformSource.Mobile]: 6,
  [PlatformSource.Desktop]: 12,
};
